import { Link } from 'react-router-dom'
import Icon from '../components/Icon'

const SECTIONS = [
  {
    icon: 'bank',
    title: 'Comptes',
    body:
      'Chaque opération est rattachée à un compte. Modifier le solde d’un compte crée une opération « Actualisation », pour que l’historique reste cohérent avec le solde affiché.',
  },
  {
    icon: 'operations',
    title: 'Opérations',
    body:
      'Une entrée augmente votre solde, une dépense le diminue. Une opération datée dans le futur n’entre pas dans le solde à ce jour, mais compte dans le solde prévisionnel.',
  },
  {
    icon: 'wallet',
    title: 'Solde à ce jour et solde prévisionnel',
    body:
      'Le solde à ce jour ne tient compte que des opérations passées. Le solde prévisionnel ajoute celles que vous avez saisies pour les jours à venir : c’est ce que vous aurez si rien ne change.',
  },
  {
    icon: 'gauge',
    title: 'Seuils et alertes',
    body:
      'Le seuil d’alerte, le solde minimum et le plafond se règlent dans Paramètres. Une fois définis, le tableau de bord indique en permanence où vous vous situez par rapport à eux.',
  },
  {
    icon: 'chart',
    title: 'Graphiques',
    body:
      'La répartition montre le poids de chaque catégorie de dépense sur la période choisie. Le comparatif mensuel met vos douze mois côte à côte.',
  },
]

export default function Aide() {
  return (
    <div className="app-page max-w-3xl">
      <div>
        <h1 className="app-page-title">Aide</h1>
        <p className="app-page-subtitle">
          Les notions à connaître pour tirer parti de Finance Prévision.
        </p>
      </div>

      <div className="card divide-y divide-line">
        {SECTIONS.map((section) => (
          <div key={section.title} className="flex gap-4 p-5">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-line bg-surface-sunken text-ink-secondary">
              <Icon name={section.icon} size={17} />
            </span>
            <div className="min-w-0">
              <h2 className="text-lg font-semibold text-ink">{section.title}</h2>
              <p className="mt-1 text-base text-ink-secondary">{section.body}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="callout-neutral">
        <Icon name="mail" size={18} className="mt-0.5 shrink-0" />
        <p>
          Une question qui n’est pas traitée ici ? Écrivez à{' '}
          <a
            href="mailto:admin@financeprevision.com"
            className="font-medium text-accent underline underline-offset-2"
          >
            admin@financeprevision.com
          </a>
          . Vous pouvez aussi consulter la page{' '}
          <Link to="/apropos" className="font-medium text-accent underline underline-offset-2">
            À propos
          </Link>
          .
        </p>
      </div>
    </div>
  )
}
